export type AssessmentType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
export namespace AssessmentType {
  export const FirstLeadership: AssessmentType & 1 = 1;
  export const FirstLeadership360: AssessmentType & 2 = 2;
  export const CoacheePreferences: AssessmentType & 3 = 3;
  export const CoachingCulture: AssessmentType & 4 = 4;
  export const CoachingStyles: AssessmentType & 5 = 5;
  export const CoachingStylesPartnershipReferrals: AssessmentType & 6 = 6;
  export const DirectReport: AssessmentType & 7 = 7;
  export const PeerToPeer: AssessmentType & 8 = 8;
}

export type AssessmentReportTemplate = 1 | 2 | 3 | 4 | 5 | 6;
export namespace AssessmentReportTemplate {
  export const CoachingStyles: AssessmentReportTemplate & 1 = 1;
  export const DirectReport: AssessmentReportTemplate & 2 = 2;
  export const CoacheePreferences: AssessmentReportTemplate & 3 = 3;
  export const PeerToPeer: AssessmentReportTemplate & 4 = 4;
  export const CoachingStylesV2: AssessmentReportTemplate & 5 = 5;
  export const FacilitatorStyles: AssessmentReportTemplate & 6 = 6;
}


export type CoachStyle = 'Rallier' | 'Educator' | 'Strategist' | 'Provocateur' | 'Explorer' | 'Confidant' | 'AssessmentType';
export namespace CoachStyle {
  export const Rallier: CoachStyle & 'Rallier' = 'Rallier';
  export const Educator: CoachStyle & 'Educator' = 'Educator';
  export const Strategist: CoachStyle & 'Strategist' = 'Strategist';
  export const Provocateur: CoachStyle & 'Provocateur' = 'Provocateur';
  export const Explorer: CoachStyle & 'Explorer' = 'Explorer'
  export const Confidant: CoachStyle & 'Confidant' = 'Confidant';
  export const Transformer: CoachStyle & 'AssessmentType' = 'AssessmentType';
}

export interface IGraphConfig {
  labels: string[]
  scores: number[]
}

export interface IReport {
  b2c: number;
  graph: {
    CoachingStyle: IGraphConfig,
    DirectIndirect: IGraphConfig,
    MasteryScore: IGraphConfig
  },
  primaryCoachingStyle: CoachStyle;
  primaryCoachingStyleDesc: string;
  secondaryCoachingStyle: CoachStyle;
  secondaryCoachingStyleDesc: string;
  leastDevCoachingStyle: CoachStyle;
  leastDevCoachingStyleDesc: string;
  combinationPrimary: string;
  combinationDescOne: string;
  combinationDescTwo: string;
  combinationDescThree: string;
  styleExpression: string;
  styleExpressionDesc: string;
  name: string;
  templateId: AssessmentType;
  templateType: string;
  completed_at: string;

  facilitatorStyleA?: string;
  facilitatorStyleADesc?: string;
  facilitatorOverview?: string;
  facilitatorOverviewDesc?: string;
  facilitatorInsight?: string;
  facilitatorInsightDesc?: string;
  facilitatorTrait?: string;
  facilitatorTraitDesc?: string;
  facilitatorTheme?: string;
  facilitatorThemeDesc?: string;
  facilitatorTakeaway?: string;
  facilitatorSummary?: string;
}
